import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Select, FormLayout, Page, Card, Button, Checkbox, TextField } from '@shopify/polaris';

import { fulfillmentOptions, fincancialOptions, orderOptions } from '@utils/recordHelpers';

import TagsInput from 'react-tagsinput';

const propTypes = {
  // values: PropTypes.object.isRequired,
  values: PropTypes.shape({
    fulfillment: PropTypes.string,
    financial: PropTypes.string,
    order_status: PropTypes.string,
    order_tags: PropTypes.array,
    excluded_location: PropTypes.string,

    ship_hero_filtering: PropTypes.bool,
  }).isRequired,

  handleChange: PropTypes.func.isRequired,
  locations: PropTypes.array,
  onTagsChange: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,

  loading: PropTypes.bool,
};

const OrderSupplyFilterForm = (props) => {
  const values = props.values;
  const emptyTags = values.order_tags.length < 1;

  const shFilter = values.ship_hero_filtering
  return(
    <Card>
      <Card.Section title="Order Filters">
        <FormLayout>
          {/* <Checkbox
            id="ship_hero_filtering"
            label="Filtrar con Ship Hero"
            checked={ shFilter }
            onChange={props.handleChange}
          /> */}

          {/* Shopify specific filters */}
          {/* { !shFilter &&
            <FormLayout.Group>
              <Select
                label={ I18n.t("shopify.fulfillment_status") }
                id="fulfillment"
                options={fulfillmentOptions}
                onChange={props.handleChange}
                value={ values.fulfillment }
              />
              <Select
                label={ I18n.t("shopify.financial_status") }
                id="financial"
                options={fincancialOptions}
                onChange={props.handleChange}
                value={ values.financial }
              />
              <Select
                label={ I18n.t("shopify.order_status") }
                id="order_status"
                options={orderOptions}
                onChange={props.handleChange}
                value={ values.order_status }
              />
              
            </FormLayout.Group>

          } */}

          <FormLayout.Group>
            { !!shFilter ? 
              // Only one ship hero status
              <TextField 
                id="ship_hero_status"
                label={ "Ship Hero Status" }
                value={ values.ship_hero_status }
                onChange={ props.handleChange }
              />
            :
              // With Shopify multiple tags can be filtered by
              <div>
                <PolarisLabel value={I18n.t("shopify.order_tags")} />
                <TagsInput
                  value={values.order_tags}
                  onlyUnique
                  addKeys={[188, 9, 13]}
                  inputProps={{
                    className: `react-tagsinput-input ${emptyTags ? 'show-placeholder' : ''}`,
                    placeholder: emptyTags ? "to buy, shipping" : '',
                  }}
                  onChange={ props.onTagsChange } />
              </div>
            }

            {/* <Select
              label={I18n.t("shopify.excluded_location")}
              id="excluded_location_id"
              options={props.locations}
              onChange={props.handleChange}
              value={values.excluded_location_id}
            /> */}

            <div></div>
          </FormLayout.Group>
          
        </FormLayout>
      </Card.Section>

      <Card.Section>
        <Button 
          loading={ props.loading }
          onClick={ props.handleSubmit }
          primary>
          { I18n.t("actions.create") }
        </Button>
      </Card.Section>
    </Card>
  );
}

const PolarisLabel = ({value}) => (
  <div className="Polaris-Labelled__LabelWrapper">
    <div className="Polaris-Label">
      <label className="Polaris-Label__Text">
        { value }
      </label>
    </div>
  </div>
)

OrderSupplyFilterForm.propTypes = propTypes;


export default OrderSupplyFilterForm;
